// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","LikeSection__button":"kg_a bhj_vr"};